<form autocomplete="off">
  <mat-form-field appearance="fill" class="hospital-selector" (click)="openHospitalSelect()">
    <mat-label>Facility</mat-label>
    <input
      #selectorRef
      type="text"
      [disabled]="disabled"
      [(ngModel)]="hospitalName"
      (keyup)="false"
      (keydown)="false"
      name="hospitalName"
      matInput/>
    <button
      matSuffix
      mat-icon-button
      aria-label="search hospital" [disabled]="disabled">
      <i class="fa fa-search"></i>
    </button>
  </mat-form-field>
</form>
